/**
 * @generated SignedSource<<c125af9a6db257bc6eedfdd4c1d0446b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type PanelistsReportQuery$variables = {
  count: number;
  cursor?: string | null;
  panelFilters?: any | null;
  searchTerm?: string | null;
};
export type PanelistsReportQuery$data = {
  readonly viewer: {
    readonly user: {
      readonly profile: {
        readonly tenant: {
          readonly panelists: {
            readonly edges: ReadonlyArray<{
              readonly cursor: string;
              readonly node: {
                readonly completedStudiesCount: number | null;
                readonly dId: any | null;
                readonly id: string;
                readonly joined: string | null;
                readonly panelistMembership: {
                  readonly latestCompleteScreenerDate: string | null;
                  readonly latestCompleteScreenerName: string | null;
                  readonly latestRatedParticipant: {
                    readonly rating: number;
                  } | null;
                  readonly latestStudyDate: string | null;
                  readonly latestStudyName: string | null;
                } | null;
                readonly person: {
                  readonly email: string | null;
                  readonly firstName: string | null;
                  readonly lastName: string | null;
                  readonly panelist: {
                    readonly id: string;
                  } | null;
                  readonly phoneNumber: string | null;
                } | null;
                readonly responses: {
                  readonly edges: ReadonlyArray<{
                    readonly node: {
                      readonly answer: {
                        readonly id: string;
                        readonly other: boolean;
                        readonly userSpecified: boolean;
                      } | null;
                      readonly characteristic: {
                        readonly id: string;
                        readonly importKey: string;
                        readonly text: string | null;
                      };
                      readonly customAnswer: string | null;
                      readonly row: {
                        readonly id: string;
                        readonly text: string;
                      } | null;
                      readonly textValue: string;
                    } | null;
                  } | null>;
                };
                readonly rewardsBalance: number | null;
              } | null;
            } | null>;
            readonly totalCount: number | null;
          } | null;
        };
      } | null;
    } | null;
  };
};
export type PanelistsReportQuery = {
  response: PanelistsReportQuery$data;
  variables: PanelistsReportQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "count"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cursor"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "panelFilters"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "searchTerm"
  }
],
v1 = {
  "kind": "Variable",
  "name": "panelFilters",
  "variableName": "panelFilters"
},
v2 = {
  "kind": "Variable",
  "name": "searchTerm",
  "variableName": "searchTerm"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dId",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "completedStudiesCount",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phoneNumber",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "PanelistNode",
  "kind": "LinkedField",
  "name": "panelist",
  "plural": false,
  "selections": [
    (v5/*: any*/)
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "latestCompleteScreenerName",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "latestCompleteScreenerDate",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "latestStudyName",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "latestStudyDate",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rating",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rewardsBalance",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "joined",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "CharacteristicNode",
  "kind": "LinkedField",
  "name": "characteristic",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "importKey",
      "storageKey": null
    },
    (v5/*: any*/),
    (v20/*: any*/)
  ],
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "CharacteristicAnswerNode",
  "kind": "LinkedField",
  "name": "answer",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "other",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userSpecified",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "CharacteristicRowNode",
  "kind": "LinkedField",
  "name": "row",
  "plural": false,
  "selections": [
    (v5/*: any*/),
    (v20/*: any*/)
  ],
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "textValue",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customAnswer",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v28 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  (v1/*: any*/),
  (v2/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PanelistsReportQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserNode",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProfileNode",
                "kind": "LinkedField",
                "name": "profile",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TenantNode",
                    "kind": "LinkedField",
                    "name": "tenant",
                    "plural": false,
                    "selections": [
                      {
                        "alias": "panelists",
                        "args": [
                          (v1/*: any*/),
                          (v2/*: any*/)
                        ],
                        "concreteType": "PanelistConnection",
                        "kind": "LinkedField",
                        "name": "__PanelistsReport_panelists_connection",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PanelistEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              (v4/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PanelistNode",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v6/*: any*/),
                                  (v7/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PersonNode",
                                    "kind": "LinkedField",
                                    "name": "person",
                                    "plural": false,
                                    "selections": [
                                      (v8/*: any*/),
                                      (v9/*: any*/),
                                      (v10/*: any*/),
                                      (v11/*: any*/),
                                      (v12/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PanelistMembershipNode",
                                    "kind": "LinkedField",
                                    "name": "panelistMembership",
                                    "plural": false,
                                    "selections": [
                                      (v13/*: any*/),
                                      (v14/*: any*/),
                                      (v15/*: any*/),
                                      (v16/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ParticipantNode",
                                        "kind": "LinkedField",
                                        "name": "latestRatedParticipant",
                                        "plural": false,
                                        "selections": [
                                          (v17/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v18/*: any*/),
                                  (v19/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CharacteristicResponseNodeConnection",
                                    "kind": "LinkedField",
                                    "name": "responses",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "CharacteristicResponseNodeEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "CharacteristicResponseNode",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v21/*: any*/),
                                              (v22/*: any*/),
                                              (v23/*: any*/),
                                              (v24/*: any*/),
                                              (v25/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v26/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v27/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PanelistsReportQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserNode",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProfileNode",
                "kind": "LinkedField",
                "name": "profile",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TenantNode",
                    "kind": "LinkedField",
                    "name": "tenant",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": (v28/*: any*/),
                        "concreteType": "PanelistConnection",
                        "kind": "LinkedField",
                        "name": "panelists",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PanelistEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              (v4/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PanelistNode",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v6/*: any*/),
                                  (v7/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PersonNode",
                                    "kind": "LinkedField",
                                    "name": "person",
                                    "plural": false,
                                    "selections": [
                                      (v8/*: any*/),
                                      (v9/*: any*/),
                                      (v10/*: any*/),
                                      (v11/*: any*/),
                                      (v12/*: any*/),
                                      (v5/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PanelistMembershipNode",
                                    "kind": "LinkedField",
                                    "name": "panelistMembership",
                                    "plural": false,
                                    "selections": [
                                      (v13/*: any*/),
                                      (v14/*: any*/),
                                      (v15/*: any*/),
                                      (v16/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ParticipantNode",
                                        "kind": "LinkedField",
                                        "name": "latestRatedParticipant",
                                        "plural": false,
                                        "selections": [
                                          (v17/*: any*/),
                                          (v5/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v5/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v18/*: any*/),
                                  (v19/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CharacteristicResponseNodeConnection",
                                    "kind": "LinkedField",
                                    "name": "responses",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "CharacteristicResponseNodeEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "CharacteristicResponseNode",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v21/*: any*/),
                                              (v22/*: any*/),
                                              (v23/*: any*/),
                                              (v24/*: any*/),
                                              (v25/*: any*/),
                                              (v5/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v26/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v27/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v28/*: any*/),
                        "filters": [
                          "panelFilters",
                          "searchTerm"
                        ],
                        "handle": "connection",
                        "key": "PanelistsReport_panelists",
                        "kind": "LinkedHandle",
                        "name": "panelists"
                      },
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "19a048331237414293ec67269dcc777a",
    "id": null,
    "metadata": {
      "connection": [
        {
          "count": "count",
          "cursor": "cursor",
          "direction": "forward",
          "path": [
            "viewer",
            "user",
            "profile",
            "tenant",
            "panelists"
          ]
        }
      ]
    },
    "name": "PanelistsReportQuery",
    "operationKind": "query",
    "text": "query PanelistsReportQuery(\n  $count: Int!\n  $cursor: String\n  $panelFilters: GenericScalar\n  $searchTerm: String\n) {\n  viewer {\n    user {\n      profile {\n        tenant {\n          panelists(first: $count, after: $cursor, panelFilters: $panelFilters, searchTerm: $searchTerm) {\n            totalCount\n            edges {\n              cursor\n              node {\n                id\n                dId\n                completedStudiesCount\n                person {\n                  firstName\n                  lastName\n                  email\n                  phoneNumber\n                  panelist {\n                    id\n                  }\n                  id\n                }\n                panelistMembership {\n                  latestCompleteScreenerName\n                  latestCompleteScreenerDate\n                  latestStudyName\n                  latestStudyDate\n                  latestRatedParticipant {\n                    rating\n                    id\n                  }\n                  id\n                }\n                rewardsBalance\n                joined\n                responses {\n                  edges {\n                    node {\n                      characteristic {\n                        importKey\n                        id\n                        text\n                      }\n                      answer {\n                        id\n                        other\n                        userSpecified\n                      }\n                      row {\n                        id\n                        text\n                      }\n                      textValue\n                      customAnswer\n                      id\n                    }\n                  }\n                }\n                __typename\n              }\n            }\n            pageInfo {\n              endCursor\n              hasNextPage\n            }\n          }\n          id\n        }\n        id\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "02707dffce2f9d1ea4e1202f373f2bfc";

export default node;
